__turbopack_context__.v({
  "card": "contact-modal-module-scss-module__Hfp9LW__card",
  "closeBtn": "contact-modal-module-scss-module__Hfp9LW__closeBtn",
  "contactIcon": "contact-modal-module-scss-module__Hfp9LW__contactIcon",
  "contactItem": "contact-modal-module-scss-module__Hfp9LW__contactItem",
  "contactLabel": "contact-modal-module-scss-module__Hfp9LW__contactLabel",
  "contactLink": "contact-modal-module-scss-module__Hfp9LW__contactLink",
  "contactList": "contact-modal-module-scss-module__Hfp9LW__contactList",
  "contactModalGlow": "contact-modal-module-scss-module__Hfp9LW__contactModalGlow",
  "contactModalItemIn": "contact-modal-module-scss-module__Hfp9LW__contactModalItemIn",
  "contactValue": "contact-modal-module-scss-module__Hfp9LW__contactValue",
  "content": "contact-modal-module-scss-module__Hfp9LW__content",
  "contentAnimated": "contact-modal-module-scss-module__Hfp9LW__contentAnimated",
  "decorBottom": "contact-modal-module-scss-module__Hfp9LW__decorBottom",
  "decorTop": "contact-modal-module-scss-module__Hfp9LW__decorTop",
  "fieldError": "contact-modal-module-scss-module__Hfp9LW__fieldError",
  "fieldRoot": "contact-modal-module-scss-module__Hfp9LW__fieldRoot",
  "fieldRootError": "contact-modal-module-scss-module__Hfp9LW__fieldRootError",
  "form": "contact-modal-module-scss-module__Hfp9LW__form",
  "formColumn": "contact-modal-module-scss-module__Hfp9LW__formColumn",
  "formColumnSuccess": "contact-modal-module-scss-module__Hfp9LW__formColumnSuccess",
  "grid": "contact-modal-module-scss-module__Hfp9LW__grid",
  "honeypot": "contact-modal-module-scss-module__Hfp9LW__honeypot",
  "input": "contact-modal-module-scss-module__Hfp9LW__input",
  "modal": "contact-modal-module-scss-module__Hfp9LW__modal",
  "overlay": "contact-modal-module-scss-module__Hfp9LW__overlay",
  "overlayOpen": "contact-modal-module-scss-module__Hfp9LW__overlayOpen",
  "sideTitle": "contact-modal-module-scss-module__Hfp9LW__sideTitle",
  "socialLink": "contact-modal-module-scss-module__Hfp9LW__socialLink",
  "socials": "contact-modal-module-scss-module__Hfp9LW__socials",
  "socialsTitle": "contact-modal-module-scss-module__Hfp9LW__socialsTitle",
  "status": "contact-modal-module-scss-module__Hfp9LW__status",
  "statusError": "contact-modal-module-scss-module__Hfp9LW__statusError",
  "statusSuccess": "contact-modal-module-scss-module__Hfp9LW__statusSuccess",
  "submitBtn": "contact-modal-module-scss-module__Hfp9LW__submitBtn",
  "subtitle": "contact-modal-module-scss-module__Hfp9LW__subtitle",
  "successBanner": "contact-modal-module-scss-module__Hfp9LW__successBanner",
  "successIcon": "contact-modal-module-scss-module__Hfp9LW__successIcon",
  "textarea": "contact-modal-module-scss-module__Hfp9LW__textarea",
  "title": "contact-modal-module-scss-module__Hfp9LW__title",
  "wrapper": "contact-modal-module-scss-module__Hfp9LW__wrapper",
  "wrapperOpen": "contact-modal-module-scss-module__Hfp9LW__wrapperOpen",
});
